import { HStack, VStack } from 'native-base';
import { useTranslation } from 'react-i18next';

import { Button, Modal, Text } from '@pimm/base';

type ModalConfirmProps = {
  message?: string;
  title?: string;
  isOpen?: boolean;
  onClose: () => void;
  onConfirm?: () => void;
};

export const ModalConfirm = ({ isOpen, message, title, ...props }: ModalConfirmProps) => {
  const { t } = useTranslation();
  return (
    <Modal hideClose noPadding isOpen={isOpen} onClose={props.onClose} size="md" _content={{ rounded: 'xl', p: 5, maxW: 400 }}>
      <VStack space={2}>
        <VStack space={4} py={2}>
          <HStack space={3} alignItems="center">
            <Text color="black" fontWeight={700} size="xl" lineHeight="xs">
              {title ?? t('account_settings:confirm_changes')}
            </Text>
          </HStack>

          <Text color="gray.900" fontWeight={500} size="md" mb={3} lineHeight="sm">
            {message ?? t('account_settings:confirm_submit_changes')}
          </Text>
        </VStack>

        <HStack space={2}>
          <Button variant="unstyled" flex={1} onPress={props.onClose}>
            {t('account_settings:cancel')}
          </Button>
          <Button flex={1} onPress={props.onConfirm}>
            {t('account_settings:confirm')}
          </Button>
        </HStack>
      </VStack>
    </Modal>
  );
};
